/* ==========================================================================
   Collapse-on-mobile for <details data-gp-collapse-mobile>.

   Long reference blocks — the nine diagnostic modes, the FAQ, the ten
   product-page detail sections — are open in the HTML and collapse only on a
   narrow viewport. That ordering is deliberate:

     · with scripts off, every answer is on the page and indexable
     · the FAQPage schema is emitted as JSON-LD regardless, so collapsing
       costs nothing in search either way
     · nothing expands after first paint, so there is no layout shift

   Re-run on resize so rotating a phone into landscape does not leave a
   desktop-width page with everything shut.
   ========================================================================== */
(() => {
  'use strict';

  const mq = window.matchMedia('(max-width: 989px)');

  function apply(scope) {
    (scope || document).querySelectorAll('details[data-gp-collapse-mobile]').forEach((el) => {
      // Once a visitor has opened or shut one themselves, it is theirs — do
      // not fight them on the next resize.
      if (el.dataset.gpTouched) return;
      const want = !mq.matches;
      el.dataset.gpSet = want ? '1' : '0';
      el.open = want;
    });
  }

  /* `toggle` fires for our own writes as well as the visitor's, and it fires
     asynchronously, so a synchronous "ignore the next one" flag is not safe.
     Comparing against the value we last wrote is. */
  document.addEventListener('toggle', (e) => {
    const el = e.target;
    if (!(el instanceof HTMLDetailsElement)) return;
    if (!el.hasAttribute('data-gp-collapse-mobile')) return;
    if (el.dataset.gpSet === (el.open ? '1' : '0')) return;
    el.dataset.gpTouched = '1';
  }, true);

  apply();
  if (mq.addEventListener) mq.addEventListener('change', () => apply());
  document.addEventListener('shopify:section:load', (e) => apply(e.target));
})();
